import { Injectable } from "@angular/core";
import { ShellDomainProvider } from "../utility/shell-domain.provider";
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map, switchMap } from 'rxjs/operators';
import {forEach,indexOf,remove} from 'lodash';

@Injectable()
export class EcapCorSecurityPermissionUpdateService {

    public actions = {
        add: "add",
        remove: "remove",
        clear: "clear"
    }
    header: any = new HttpHeaders({
        'Content-Type': 'application/json'
    });

    constructor(private http: HttpClient) {
    }
    getRowLevelSecurity(payload): Observable<any> {
        return this.http.post(ShellDomainProvider['api'].DataCore + 'DataManipulationQuery/GetRowLevelSecurity',
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    changeSecurityPermission(payload): any {
        return this.http.post(ShellDomainProvider['api'].DataCore + 'DataManipulationCommand/ChangeSecurityPermission',
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }
    changeSecurityPermissionWithRowLevelSecurity(payload): any {
        return this.http.post(ShellDomainProvider['api'].DataCore + 'DataManipulationCommand/ChangeSecurityPermissionWithRowLevelSecurity',
            payload,
            { headers: this.header, withCredentials: true, observe: 'response' });
    }

    /* Update row level security of item with permissions
                 [{
                    "Prop": "RolesAllowedToRead",
                    "Action": "add",
                    "Value": ["admin"]
                },
                {
                    "Prop": "RolesAllowedToDelete",
                    "Action": "remove",
                    "Value": "appuser"
                },
                {
                    "Prop": "RolesAllowedToDelete",
                    "Action": "clear",
                    "Value": ""
                }]
    */
    updateRowLevelSecurity(item, entityName, permissions): any {
        return this.getRowLevelSecurityOfItem(item, entityName).pipe(switchMap(responseItemSecurity => {
            let requestBody = this.getRequestPermissionPayload(item, entityName, responseItemSecurity && responseItemSecurity[0], permissions);
            return this.changeSecurityPermission(requestBody);
        }));
    }

    getRowLevelSecurityOfItem(itemId, entityName): any {
        let requestPayload = {
            ItemId: itemId,
            EntityName: entityName
        }
        return this.getRowLevelSecurity(requestPayload).pipe(map((response: any) => {
            if (response && response.body) {
                return response.body.Results;
            } else {
                return null;
            }
        }))
    }

    getRequestPermissionPayload(item, entityName, responseItemSecurity, securityPayload): any {
        forEach(securityPayload, (category) => {
            responseItemSecurity[category.Prop] = this.getPropertyValue(responseItemSecurity[category.Prop], category);
        });
        responseItemSecurity.EntityName = entityName;
        return responseItemSecurity;
    }

    getPropertyValue(existingvalue, category): any {
        if (!existingvalue) existingvalue = [];
        if (category && category.Action == this.actions.add) {
            forEach(category.Value, (value) => {
                if (!this.isAlreadyExistValue(existingvalue, value)) {
                    let values = existingvalue.push(value);
                }
            });
            return existingvalue;
        } else if (category && category.Action == this.actions.remove) {
            remove(existingvalue, (value) => {
                return value == category.Value;
            });
            return existingvalue;
        } else if (category && category.Action == this.actions.clear) {
            return [];
        }
    }
    isAlreadyExistValue(existingvalue, value) {
        return indexOf(existingvalue, value) > -1 ? true : false;
    }
}